export const BRAND = {
    name: "Momia Healthcare Exports",
    short: "Momia",
    tagline: "Global exporters of pharmaceuticals, healthcare & turnkey hospital solutions",
    website: "www.momia.org",
    websiteUrl: "https://www.momia.org",
    whatsapp: "+919878068899",
    whatsappDisplay: "+91 98780 68899",
    email: "sujit@momia.org",
    facebook: "https://www.facebook.com/YASHPALMOMIA",
    zoomUrl: "https://us05web.zoom.us/j/83804814980?pwd=aXCY1lZuLlcNbda4p4WvIxCCDkgMY2.1",
    zoomMeetingId: "838 0481 4980",
    zoomPasscode: "aXCY1lZuLlcNbda4p4WvIxCCDkgMY2.1",
    principal: "Yashpal Momia",
    principalPhoto: "https://customer-assets.emergentagent.com/job_pharma-health-hub-1/artifacts/snt3wlkr_me.jpg",
    logo: "https://customer-assets.emergentagent.com/job_pharma-health-hub-1/artifacts/e7zi950e_Logo%20%282%29%207.png",
    adoreLogo: "https://customer-assets.emergentagent.com/job_pharma-health-hub-1/artifacts/4i516vq8_logo%20adore%20Lifestyles%20.jpg",
    legal: {
        momiaGST: "06AAMCM7464P1ZL",
        momiaCIN: "U85110HR2019PTC080989",
        momiaPAN: "AAMCM7464P",
        adoreGST: "06AKYPM8238N1Z3",
        state: "Haryana, India",
    },
};

export const STATS = [
    { value: "120+", label: "Molecules Supplied" },
    { value: "45+", label: "Countries Served" },
    { value: "WHO-GMP", label: "Manufacturing Partners" },
    { value: "25+", label: "Years of Expertise" },
];
